module.exports = __webpack_public_path__ + "static/car-part-6205e96f4af1a89dcd0c16bbe51bed0e.png";